import classNames from 'classnames';
import React from 'react';
import styles from './GoogleSignInButton.module.css';

interface Props {
  // light?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}
export const GoogleSignInButton: React.FunctionComponent<Props> = ({
  // light,
  disabled,
  onClick,
  className,
}) => (
  <button
    className={classNames(styles.button, className, {
      // [styles.light]: light,
      [styles.disabled]: disabled,
    })}
    disabled={disabled}
    onClick={onClick}
  />
);
